import Moment from "moment";
import { extendMoment } from "moment-range";

const moment = extendMoment(Moment);

const date = [
  {
    open: "2023-10-16",
    close: "2023-12-30",
    test: "2024-01-06",
    result: "2024-01-15",
    wave: 1,
  },
  {
    open: "2030-02-27",
    close: "2030-05-06",
    test: "2030-05-16",
    result: "2030-05-28",
    wave: 2,
  },
  {
    open: "2030-06-12",
    close: "2030-06-17",
    test: "2030-06-19",
    result: "2030-06-23",
    wave: 3,
},
  {
    open: "2040-07-01",
    close: "2040-07-01",
    test: "2040-07-01",
    result: "2040-07-01",
    wave: 4,
  },
];

export default function auth({ next, router }) {
  moment.locale("id");

  const currentTime = moment(localStorage.getItem("date"));

  const currentWave = date.filter((itemDate) => {
    const range = moment().range(moment(itemDate.open), moment(itemDate.close));
    return range.contains(currentTime);
  });

  if (currentWave.length <= 0)
    return router.push({
      name: "home",
    });

  return next();
}
